<template>
  <div id="main-content">
    <div class="wrapper">
      <div class="table-agile-info">
        <jm-crumbs/>
        <jm-toolbar customize-field-name="">
        </jm-toolbar>
        <el-form
          :inline="true"
          :model="searchData">
          <el-form-item>
            <el-select v-model="searchData.country_id" placeholder="请选择">
              <el-option
                v-for="item in dict.country"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchData.month"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="reLoad()">查询</el-button>
          </el-form-item>
        </el-form>
        <div class="div-tabal">
          <div class="tabel-heard">
            <div class="tabel-th name-td">
              <el-popover
                placement="right"
                width="80"
                trigger="hover"
              >
                <div style="text-align: left; margin: 0">
                  <ul>
                    <li v-for="(item,index) in this.initGroupColor()" :key="index">
                      <i :class="item.class" style="width:10px;height:10px;display:inline-block;margin-right:5px;"></i>:&nbsp;{{ item.name }}
                    </li>
                  </ul>
                </div>
                <div
                  slot="reference"
                  class="el-icon-question"
                > </div>
              </el-popover>
            </div>
            <div class="tabel-th data-td" v-for="(item, i) in days" :key="i">{{ item }}</div>
          </div>
          <div class="tabel-heard">
            <div class="tabel-th name-td">姓名</div>
            <div class="tabel-th data-td" v-for="(item, i) in weeks" :key="i">
              <span :class="['周六', '周日'].indexOf(item) > -1 ? 'weekend' : ''">{{ item }}</span>
            </div>
          </div>
          <div class="tabel-body" v-for="(row, i) in info" title="点击姓名查看日期" :key="i">
            <div class="tabel-td name-td" @click="showDate(row)">
              <span class="red" v-if="row.testkey">【测】</span>
              {{ row.truename }}
            </div>
            <div class="tabel-td data-td" v-for="(vv, kk) in row.data" :key="kk">
              <span v-if="!row.display"
                    :class="initClass(vv, kk, row.group_id)"
                    @click="showDialog(row.userid, vv, kk)"
              >
                {{ vv.type === 'rest' ? '休' : '' }}
                <span v-if="vv.time !== undefined">
                  {{ vv.time[0] }}<br />{{ vv.time[1] }}
                </span>
              </span>
              <span v-if="row.display"
                    :class="initClass(vv, kk, row.group_id)"
                    @click="showDialog(row.userid, vv, kk)"
              >
                {{ kk }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="40%" title="工作状态设置" :visible.sync="dialogVisible">
      <el-form>
        <el-form-item label="日期" label-width="100px">
          <el-date-picker v-model="working.date" readonly>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" label-width="100px">
          <el-radio-group v-model="working.type">
            <el-radio-button label="rest" key="rest">休息</el-radio-button>
            <el-radio-button label="work" key="work">工作</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="时间段" label-width="100px" v-if="working.type === 'work'">
          <el-time-select
            placeholder="起始时间"
            v-model="working.startTime"
            :picker-options="dutyTimeOptions">
          </el-time-select>
          至
          <el-time-select
            placeholder="结束时间"
            v-model="working.endTime"
            :picker-options="dutyTimeOptions">
          </el-time-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button @click="changSchedule" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import '@/assets/css/group-color.css';

const dutyTimeOptions = {
  start: '00:00',
  step: '00:30',
  end: '24:00'
};

export default {
  data() {
    let date = new Date();
    let month = `${date.getFullYear()}-${date.getMonth() + 1}`;
    return {
      dutyTimeOptions,
      working: {
        userid: 0,
        date: '',
        type: 'work',
        startTime: '00:00',
        endTime: '24:00'
      },
      dialogVisible: false,
      refresh: false,
      searchData: { country_id: 0, month: month },
      info: [],
      days: [],
      weeks: [],
      group_info: [],
      dict: {
        country: [],
        groups: []
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
  },
  computed: {},
  methods: {
    showDialog(userid, duty, day) {
      this.dialogVisible = true;
      if (!duty.time) {
        duty.time = ['00:00', '24:00'];
      }

      this.working = Object.assign({}, {
        userid: userid,
        type: duty.type,
        date: `${this.searchData.month}-${day}`,
        startTime: duty.time[0],
        endTime: duty.time[1]
      });
    },
    changSchedule() { // 编辑
      this.$http._post({
        url: 'index/Teacher/changeTeacherSchedule',
        data: this.working,
      }).then((res) => {
        if (res.result === 0) {
          this.$message({ type: 'success', message: '保存成功!' });
          this.dialogVisible = false;
          this.reLoad();
        }
      });
    },
    reLoad() {
      this.$http._post({
        url: 'index/Teacher/getTeacherSchedule',
        data: this.searchData,
      }).then(({ data }) => {
        this.info = data.teacher;
        this.days = data.days;
        this.weeks = data.weeks;
        this.group_info = data.group_info;
      });
    },
    initClass(v, k, groupId) {
      let classStr = '';
      if (v.type === 'work') {
        if (v.time !== undefined) {
          classStr += 'work duty'; // 值班
        } else {
          classStr += 'work';
        }
        classStr += ` group-${groupId}`;
      } else {
        classStr += 'rest';
      }

      if (['周六', '周日'].indexOf(this.weeks[k - 1]) > -1) {
        classStr += ' weekend';
      }
      return classStr;
    },
    showDate(row) {
      row.display = !row.display;
    },
    initGroupColor() {
      let colorArr = [{
        name: '未分组',
        class: 'group-0'
      }];
      let lGroup = this.group_info.length;
      if (lGroup) {
        for (let i = 0; i < lGroup; i++) {
          colorArr.push({ name: this.group_info[i].truename, class: `group-${this.group_info[i].gid}` });
        }
      }
      return colorArr;
    }
  },
  created() {
    this.$http._post({
      url: 'index/Teacher/getDic',
    }).then(({ data }) => {
      this.dict = data;
      if (this.dict.country.length >= 2) {
        this.dict.country.unshift({ id: 0, value: '全部' });
      }
      this.searchData.country_id = this.dict.country[0].id;
      this.reLoad();
    });
  }
};
</script>

<style>
.div-tabal .el-icon-question:before{
  font-size: 20px;
  cursor: pointer;
  margin-top: 2px;
  background: rgb(84, 173, 239);
  color: #fff;
  border-radius: 50%;
  border: 1px solid rgb(84, 173, 239);
}
  .red {
    color: red;
  }
  .el-form-item {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .div-tabal {
    line-height: 40px;
    overflow-x: auto;
  }
  .tabel-heard {
    color: #fff;
    padding: 0px;
    white-space: nowrap;
  }
  .tabel-body {
    padding: 0px;
    white-space: nowrap;
    font-size: 0
  }
  .tabel-body:hover .tabel-td {
    border: 0px;
    /*border: 1px solid #fff;*/
  }
  .tabel-th {
    text-align: center;
    background-color: #01142d;
    /*border: 1px solid #fff;*/
    display: inline-block;
    padding: 0px;
    margin: 0px;
    height: 40px;
    vertical-align: middle
  }
  .tabel-td {
    border: 1px solid #fff;
    display: inline-block;
    padding: 0px;
    margin: 0px;
    height: 40px;
    font-size: 12px;
    vertical-align: middle
  }
  .tabel-body .data-td .weekend.work{
    opacity: 0.6;
  }
  /* .tabel-body .data-td .rest{
    background-image: url(../../assets/images/work-duty.png);
  } */
  .tabel-body .data-td .work.duty{
    background-image: url(../../assets/images/work-duty.png);
  }
  .tabel-body .data-td .work.duty>span{
    display: block;
    line-height: 16px;
    padding-top: 4px;
    padding-bottom: 4px;
    height: 30px;
  }
  .clearfix2 {
    display: block;
    clear: both;
    height: 0;
    border:none;
    overflow: hidden
  }
  .name-td {
    width: 120px;
  }
  .data-td {
    width: 40px;
    text-align: center;
  }
  .weekend {
    color: red;
  }
  .data-td>span {
    display: block;
    width: 100%;
    height: 100%;
  }
</style>
